export const DEFAULT_LOCALE = "pt-PT";

const LOREM_SHORT = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.";
const LOREM_MEDIUM = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";
const LOREM_LONG = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.";

export function placeholder(type) {
  switch (type) {
    case "short": return LOREM_SHORT;
    case "medium": return LOREM_MEDIUM;
    case "long": return LOREM_LONG;
    default: return LOREM_SHORT;
  }
}

export const PLACEHOLDER_IMAGE = "https://placehold.co/1200x800/f5f0eb/c8a97e?text=Placeholder";
export const PLACEHOLDER_IMAGE_HERO = "https://placehold.co/2400x1600/f5f0eb/c8a97e?text=Hero+Placeholder";
export const PLACEHOLDER_INSTAGRAM = "https://www.instagram.com/";
export const PLACEHOLDER_INSTAGRAM_HANDLE = "@placeholder";
export const PLACEHOLDER_DOMAIN = "example.com";

// Portfolio categories
export const CATS = ["Imobiliário", "Consultoria", "Design"];

// Lead statuses
export const STATUSES = ["new", "contacted", "qualified", "closed"];
export const STATUS_LABELS = { new: "Novo", contacted: "Contactado", qualified: "Qualificado", closed: "Fechado" };
export const STATUS_COLORS = {
  new: "bg-amber-50 text-amber-700 border-amber-200",
  contacted: "bg-blue-50 text-blue-700 border-blue-200",
  qualified: "bg-green-50 text-green-700 border-green-200",
  closed: "bg-gray-50 text-gray-700 border-gray-200",
};
export const STATUS_DOT = {
  new: "bg-amber-400",
  contacted: "bg-blue-400",
  qualified: "bg-green-400",
  closed: "bg-gray-400",
};

// Page sizes
export const PAGE_SIZES = [5, 10, 20, 50];

// Contact validation
export const VALIDATION_REQUIRED_FIELDS = ["Nome", "Email", "Telefone", "Serviço", "Contacto", "Nacionalidade", "Mensagem"];
export const VALIDATION_EMAIL_INVALID = "Email inválido.";
export const DEFAULT_PHONE_PREFIX = "+351";

// FAQ
export const FAQ_DEFAULT_CATEGORY = "Geral";

// REGEX
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Empty states
export const EMPTY_LEADS = "Nenhum lead encontrado.";
export const EMPTY_PORTFOLIO = "Nenhum projeto encontrado.";
export const EMPTY_TESTIMONIALS = "Nenhum depoimento cadastrado.";
export const EMPTY_FAQ = "Nenhuma FAQ cadastrada.";
export const EMPTY_FAQ_CATEGORIES = "Nenhuma categoria configurada.";
export const EMPTY_ROLES = "Nenhum role configurado.";
export const EMPTY_FORM_SERVICES = "Nenhum serviço configurado";
export const EMPTY_FORM_METHODS = "Nenhum método configurado";
export const EMPTY_FORM_PREFIXES = "Nenhum prefixo configurado";
export const EMPTY_FORM_NATIONALITIES = "Nenhuma nacionalidade configurada";

// Default form objects
export const DEFAULT_EMPTY_TESTIMONIAL = { name: "", role: "", quote: "", avatar_url: "", published: true };
export const DEFAULT_EMPTY_PORTFOLIO_ITEM = { title: "", category: CATS[0], description: "", image_url: "", featured: false, published: true };
export const DEFAULT_EMPTY_ROLE = { name: "", label: "", color: "#C8A97E" };
export const DEFAULT_EMPTY_SERVICE = { title: "Novo Serviço", description: "Descrição do serviço...", bullets: ["Destaque 1", "Destaque 2", "Destaque 3"], published: false };
export const DEFAULT_EMPTY_FAQ = { question: "", answer: "", categoryUid: "" };
export const DEFAULT_EMPTY_FAQ_QUESTION = { name: "", email: "", question: "" };
export const DEFAULT_EMPTY_LEAD = { name: "", email: "", phonePrefix: DEFAULT_PHONE_PREFIX, phone: "", nationality: "", service: "", message: "", contactMethod: "" };

// More empty states
export const EMPTY_EMAIL_LOGS = "Nenhum registo encontrado.";
export const EMPTY_EMAIL_PROCESSES = "Nenhum processo configurado";
export const EMPTY_EMAIL_RECIPIENTS = "Nenhum destinatário";
export const EMPTY_LOCALES = "Nenhum idioma encontrado.";
export const EMPTY_USERS = "Nenhum utilizador encontrado";
export const EMPTY_NAV_LINKS = "Nenhum link configurado";
export const EMPTY_PORTFOLIO_CADAST = "Nenhum projeto cadastrado.";
export const EMPTY_SEARCH_RESULT = "Nenhum resultado encontrado.";
export const EMPTY_FAQ_QUESTIONS = "Nenhuma pergunta recebida.";
export const EMPTY_BLOG_POSTS = "Nenhum artigo publicado.";
export const EMPTY_NO_CHANGES = "Nenhuma alteração para guardar.";

// ARIA labels
export const ARIA_SCROLL_TOP = "Ir para o topo da página";
export const ARIA_LANG = "Idioma";
export const ARIA_MENU = "Menu";
export const ARIA_PREV = "Anterior";
export const ARIA_NEXT = "Próximo";

// Toast messages
export const TOAST_SAVED = "Salvo.";
export const TOAST_SAVE_ERROR = "Erro ao salvar";
export const TOAST_UPDATED = "Atualizado";
export const TOAST_LOAD_ERROR = "Erro ao carregar dados";
export const TOAST_NO_PERMISSION = "Sem permissão para editar.";
export const TOAST_IMAGE_UPLOADED = "Imagem carregada.";
export const TOAST_IMAGE_ERROR = "Falha ao carregar imagem.";
export const TOAST_REQUIRED = "Campo obrigatório";
export const TOAST_REMOVED = "Removido.";
export const TOAST_REMOVE_ERROR = "Erro ao remover";
export const TOAST_ADDED = "Adicionado";
export const TOAST_ADD_ERROR = "Erro ao adicionar";
export const TOAST_LOGIN_SUCCESS = "Bem-vinda de volta.";
export const TOAST_LOGIN_ERROR = "Não foi possível autenticar.";
export const TOAST_PASSWORD_MISMATCH = "Palavras-passe não coincidem.";
export const TOAST_PASSWORD_MIN = "Mínimo 6 caracteres.";
export const TOAST_PASSWORD_CHANGED = "Palavra-passe alterada. Email de confirmação enviado.";
export const TOAST_PASSWORD_ERROR = "Falha ao alterar palavra-passe.";
export const TOAST_EMAIL_SENT = "Email reenviado com sucesso";
export const TOAST_EMAIL_ERROR = "Erro ao reenviar email";
export const TOAST_PROFILE_UPDATED = "Perfil e conta atualizados.";
export const TOAST_PROFILE_ERROR = "Falha ao salvar as alterações.";
export const TOAST_PHOTO_UPDATED = "Foto atualizada.";
export const TOAST_PHOTO_ERROR = "Falha ao enviar foto.";

// Tooltips
export const TIP_EDIT = "Editar";
export const TIP_DELETE = "Eliminar";
export const TIP_REMOVE = "Remover";
export const TIP_TRANSLATE = "Traduzir";
export const TIP_HIDE = "Clique para ocultar";
export const TIP_PUBLISH = "Clique para publicar";
export const TIP_UNPUBLISH = "Clique para despublicar";
export const TIP_REMOVE_SERVICE = "Remover Serviço";
export const TIP_REMOVE_IMAGE = "Remover Imagem";
export const TIP_REMOVE_PHOTO = "Remover Foto";
export const TIP_REMOVE_INDICATOR = "Remover indicador";
export const TIP_EMAIL_PREVIEW = "email preview";

// Login page
export const LOGIN_HEADER = "Área restrita";
export const LOGIN_FORM_TITLE = "Acesso administrativo";
export const LOGIN_FORM_HEADING = "Entrar";
export const LOGIN_FORM_DESC = "Utilize suas credenciais para gerenciar leads, portfólio e depoimentos.";
export const LOGIN_EMAIL_PLACEHOLDER = "admin@hub.com";
export const LOGIN_PASSWORD_PLACEHOLDER = "••••••••";
export const LOGIN_SUBMIT = "Entrar";
export const LOGIN_SUBMITTING = "Entrando…";

// Admin form placeholders
export const PLH_SEARCH = "Buscar...";
export const PLH_SEARCH_PROJECT = "Buscar projeto...";
export const PLH_SEARCH_LEAD = "Buscar leads...";
export const PLH_SEARCH_LOCALE = "Buscar por código ou nome...";
export const PLH_SEARCH_EMAIL = "Buscar por email ou assunto...";
export const PLH_NAME = "Nome";
export const PLH_FULL_NAME = "Nome completo";
export const PLH_EMAIL = "email@exemplo.com";
export const PLH_PUBLIC_NAME = "Seu nome público";
export const PLH_USER_NAME = "Nome real ou admin";
export const PLH_OPTIONAL = "Opcional";
export const PLH_MIN_PASSWORD = "Mínimo 6 caracteres";
export const PLH_LABEL = "Label do link";
export const PLH_HREF = "#section-id";
export const PLH_CODE = "ex: fr";
export const PLH_LANG_NAME = "ex: Français";
export const PLH_FLAG = "ex: 🇫🇷";
export const PLH_ROLE_NAME = "ex: editor, viewer";
export const PLH_ROLE_LABEL = "ex: Editor de Conteúdo";
export const PLH_ROLE_COLOR = "#C8A97E";
export const PLH_SERVICE_NAME = "Ex: Consultoria";
export const PLH_METHOD_NAME = "Ex: WhatsApp";
export const PLH_NATIONALITY = "Ex: Portuguesa";
export const PLH_PHONE_PREFIX = "+351";
export const PLH_COUNTRY = "Portugal";
export const PLH_FLAG_EMOJI = "🇵🇹";
export const PLH_PROJECT_NAME = "Nome do projeto";
export const PLH_PROJECT_DESC = "Descrição do projeto";
export const PLH_FAQ_QUESTION = "Ex: Como funciona o processo?";
export const PLH_FAQ_ANSWER = "Ex: O processo começa com uma consultoria gratuita...";
export const PLH_FAQ_REPLY = "Digite sua resposta...";
export const PLH_CATEGORY = "Ex: Consórcio";
export const PLH_TESTIMONIAL = "Escreva aqui o depoimento do cliente...";
export const PLH_PROCESS_NAME = "ex: new_lead, password_change";
export const PLH_PROCESS_LABEL = "ex: Novo Lead";
export const PLH_EMAIL_SUBJECT = "Novo Lead — {service}";
export const PLH_EMAIL_FROM = "Hub Profissional";
export const PLH_EMAIL_RECIPIENT = "email@exemplo.com";
export const PLH_EMAIL_GROUP = "Principal";
export const PLH_EMAIL_HTML = "Cole seu HTML aqui...";
export const PLH_EMAIL_TEST = "email@teste.com";
export const PLH_INSTAGRAM_URL = "https://www.instagram.com/...";
export const PLH_PHONE = "+351 900 000 000";
export const PLH_CONTACT_EMAIL = "contato@exemplo.com";
export const PLH_HERO_EYEBROW = "Ex: CONSULTORIA · DESIGN · PATRIMÔNIO";
export const PLH_HERO_HEADLINE = "O título principal do seu site...";
export const PLH_HERO_SUB = "Uma breve descrição que complementa o título...";
export const PLH_IMG_ALT = "Descreva a imagem para leitores de tela...";
export const PLH_SINCE = "Ex: 2014";
export const PLH_WA_MSG = "Mensagem padrão...";
export const PLH_PARAGRAPH = (i) => `Parágrafo ${i + 1}...`;
export const PLH_PLUS = "+";

// UI Config placeholders
export const PLH_LOGO = "ex: Hub";
export const PLH_SUBTITLE = "ex: Consultoria · Património · Design";
export const PLH_CTA_LABEL = "ex: Agendar Consultoria";

// Section texts placeholders
export const PLH_SECTION_EYEBROW = "ex: PORTFÓLIO";
export const PLH_SECTION_HEADLINE = "ex: Projetos em Destaque";
export const PLH_SECTION_DESC = "Descrição";
export const PLH_ALL_CATEGORIES = "ex: Todas";
export const PLH_NO_PROJECTS = "ex: Nenhum projeto encontrado";
export const PLH_CTA_SECONDARY = "ex: Falar no WhatsApp";
export const PLH_CTA_TERTIARY = "ex: Conhecer Serviços";
export const PLH_WA_MESSAGE = "ex: Olá, gostaria de saber mais sobre os serviços.";
export const PLH_SCROLL = "ex: Scroll";
export const PLH_SERVICES_EYEBROW = "ex: NOSSAS FRENTES";
export const PLH_SERVICES_HEADLINE = "ex: Soluções Sob Medida";
export const PLH_SERVICES_LEARN_MORE = "ex: Saber mais";
export const PLH_SERVICES_DESC = "Descrição da secção de serviços";
export const PLH_FAQ_EYEBROW = "ex: FAQ";
export const PLH_FAQ_HEADLINE = "ex: Dúvidas Frequentes";
export const PLH_FAQ_DESC = "Descrição da secção FAQ";
export const PLH_BLOG_EYEBROW = "ex: EDITORIAL";
export const PLH_BLOG_HEADLINE = "ex: Blog & Artigos";
export const PLH_BLOG_DESC = "Descrição da secção de blog";
export const PLH_BLOG_READ_MORE = "ex: Ler mais";
export const PLH_BLOG_EXCERPT = "Ex: Uma breve introdução ao artigo...";
export const PLH_BLOG_TITLE = "ex: Tendências do Mercado Imobiliário 2026";
export const PLH_BLOG_CATEGORY = "ex: Investimentos";
export const PLH_BLOG_CONTENT = "Escreva o conteúdo do artigo...";
export const PLH_BLOG_SLUG = "ex: tendencias-mercado-imobiliario-2026";
export const PLH_EMAIL_PROCESS_FROM = "noreply@example.com";

// Loader defaults
export const DEFAULT_LOADER = {
  bgClass: "bg-offwhite",
  textClass: "font-serif text-2xl animate-pulse text-softblack",
  accentClass: "text-champagne",
  text: "Hub",
  accent: ".",
};

export const TRANSLATE_MESSAGES = [
  "A organizar o conteúdo...",
  "A analisar o contexto do texto...",
  "A preparar a tradução...",
  "A identificar elementos importantes...",
  "A estruturar a informação...",
  "A processar os campos selecionados...",
  "A alinhar o conteúdo com o idioma de destino...",
  "A verificar a consistência do texto...",
  "A preservar a formatação original...",
  "A otimizar a qualidade da tradução...",
  "A sincronizar recursos linguísticos...",
  "A interpretar expressões e contexto...",
  "A adaptar o conteúdo para uma leitura natural...",
  "A validar a estrutura dos dados...",
  "A organizar os blocos de conteúdo...",
  "A construir uma versão localizada...",
  "A afinar detalhes linguísticos...",
  "A verificar termos específicos...",
  "A aplicar melhorias de contexto...",
  "A harmonizar o conteúdo traduzido...",
  "A preparar o resultado final...",
  "A concluir a análise semântica...",
  "A sincronizar o protocolo de tradução...",
  "A compilar o modelo linguístico...",
  "A processar dependências do conteúdo...",
  "A otimizar a fluidez do texto...",
  "A validar a tradução gerada...",
  "A finalizar os últimos ajustes...",
  "A preparar a entrega do conteúdo...",
  "Tradução concluída em breve...",
];
